import { assert } from '@ember/debug';
import Component from '@glimmer/component';
export class BaseValidationComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    assert('@changeset is required', typeof args.changeset === 'object');
    assert('@validationField is required', typeof args.validationField === 'string');
  }
  get hasError() {
    return this.errors.length > 0;
  }
  get firstError() {
    return this.errors[0];
  }
  get errors() {
    return this.args.changeset.errors.filter(err => err.key === this.args.validationField) ?? [];
  }
}